import { createFileRoute } from '@tanstack/react-router';
import { UsersListPage } from '@pages/users';

/** Personen-Fans-Route (/persons/fans) — Alle Personen inkl. Discord-Import */
export const Route = createFileRoute('/_authenticated/persons/fans')({
  component: () => <UsersListPage filterClerkOnly={false} />,
});
